import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { useGameStore } from '../store/gameStore';
import { cardAPI, battleAPI } from '../services/api';
import './CardLibrary.css';
function CardLibrary() {
    const { userCards, setUserCards, user, setUser, setCurrentPage } = useGameStore();
    const [drawsLeft, setDrawsLeft] = useState(0);
    const [loading, setLoading] = useState(false);
    const [lastDrawn, setLastDrawn] = useState(null);
    const [selectedAttribute, setSelectedAttribute] = useState('all');
    useEffect(() => {
        fetchDailyDraws();
    }, []);
    const fetchDailyDraws = async () => {
        try {
            const response = await battleAPI.getDailyDraws();
            setDrawsLeft(response.data.remainingDraws);
        }
        catch (error) {
            console.error('Failed to fetch daily draws:', error);
        }
    };
    const handleDrawCard = async () => {
        if (drawsLeft <= 0) {
            alert('No free draws remaining today! Come back tomorrow.');
            return;
        }
        setLoading(true);
        try {
            const response = await cardAPI.drawCard();
            setLastDrawn(response.data.card);
            setDrawsLeft(drawsLeft - 1);
            // Refresh user cards
            const cardsRes = await cardAPI.getUserCards();
            setUserCards(cardsRes.data);
        }
        catch (error) {
            alert('Failed to draw card: ' + error.response?.data?.error);
        }
        finally {
            setLoading(false);
        }
    };
    const filteredCards = selectedAttribute === 'all'
        ? userCards
        : userCards.filter((card) => card.attribute === selectedAttribute);
    const attributes = ['all', 'fire', 'water', 'earth', 'wind', 'light', 'dark'];
    const attributeEmojis = {
        fire: '🔥',
        water: '💧',
        earth: '🪨',
        wind: '🌪️',
        light: '⭐',
        dark: '🌑'
    };
    const attributeColors = {
        fire: 'from-red-600 to-orange-500',
        water: 'from-blue-600 to-cyan-500',
        earth: 'from-amber-700 to-yellow-600',
        wind: 'from-teal-600 to-green-500',
        light: 'from-yellow-400 to-white',
        dark: 'from-purple-900 to-indigo-800'
    };
    const rarityColors = {
        common: 'bg-gray-500',
        rare: 'bg-blue-500',
        epic: 'bg-purple-500',
        legendary: 'bg-yellow-500'
    };
    return (_jsxs("div", { className: "card-library", children: [_jsxs("div", { className: "library-header", children: [_jsxs("div", { style: { display: 'flex', alignItems: 'center', gap: '15px' }, children: [_jsx("button", { className: "btn-back-library", onClick: () => setCurrentPage('home'), children: "\u2190 \u8FD4\u56DE" }), _jsx("h2", { children: "\uD83C\uDFB4 Card Library" })] }), _jsxs("div", { className: "draw-info", children: [_jsxs("span", { className: "draw-counter", children: ["Free Draws: ", drawsLeft, "/3"] }), _jsx("button", { className: "btn-draw", onClick: handleDrawCard, disabled: loading || drawsLeft === 0, children: loading ? 'Drawing...' : 'Draw Card' })] })] }), lastDrawn && (_jsx("div", { className: "draw-result", children: _jsxs("div", { className: "card-preview", children: [_jsx("h3", { children: lastDrawn.name }), _jsxs("div", { className: "card-stats", children: [_jsxs("div", { className: "stat", children: [_jsx("span", { className: "label", children: "Attribute" }), _jsxs("span", { className: "value", children: [attributeEmojis[lastDrawn.attribute], " ", lastDrawn.attribute.toUpperCase()] })] }), _jsxs("div", { className: "stat", children: [_jsx("span", { className: "label", children: "Rarity" }), _jsx("span", { className: `value rarity-${lastDrawn.rarity}`, children: lastDrawn.rarity.toUpperCase() })] }), _jsxs("div", { className: "stat", children: [_jsx("span", { className: "label", children: "Damage" }), _jsx("span", { className: "value", children: lastDrawn.base_damage })] }), _jsxs("div", { className: "stat", children: [_jsx("span", { className: "label", children: "HP" }), _jsx("span", { className: "value", children: lastDrawn.base_hp })] })] })] }) })), _jsxs("div", { className: "filter-section", children: [_jsx("h3", { children: "Filter by Attribute" }), _jsx("div", { className: "attribute-filters", children: attributes.map((attr) => (_jsx("button", { className: `filter-btn ${selectedAttribute === attr ? 'active' : ''}`, onClick: () => setSelectedAttribute(attr), children: attr === 'all' ? '📋 All' : `${attributeEmojis[attr] || ''} ${attr.charAt(0).toUpperCase() + attr.slice(1)}` }, attr))) })] }), _jsx("div", { className: "cards-grid", children: filteredCards.map((card) => (_jsx("div", { className: "card-item", children: _jsxs("div", { className: `card-body bg-gradient-to-br ${attributeColors[card.attribute]}`, children: [_jsx("div", { className: "card-shine" }), _jsxs("div", { className: "card-header", children: [_jsx("h4", { children: card.name }), _jsx("span", { className: "attribute", children: attributeEmojis[card.attribute] })] }), _jsx("div", { className: "card-illustration", children: _jsx("div", { className: "attr-icon text-5xl", children: attributeEmojis[card.attribute] }) }), _jsxs("div", { className: "card-content", children: [_jsxs("div", { className: "card-stat", children: [_jsx("span", { className: "label", children: "ATK" }), _jsx("span", { className: "value", children: card.base_damage })] }), _jsxs("div", { className: "card-stat", children: [_jsx("span", { className: "label", children: "HP" }), _jsx("span", { className: "value", children: card.base_hp })] })] }), _jsxs("div", { className: "card-footer", children: [_jsx("span", { className: `rarity-badge ${rarityColors[card.rarity]}`, children: card.rarity.toUpperCase() }), _jsxs("span", { className: "card-count", children: ["\u00D7", card.count || 1] })] })] }) }, `${card.id}-${card.count}`))) })] }));
}
export default CardLibrary;
